import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();

    if (!auth?.user) {
        navigate("/");
        return null;
    }

    return (
        <h1>Home page</h1>
    )
};

export default Dashboard;